import React, { useState, useEffect } from 'react';
import { api } from '../api';
import HelpButton from '../components/HelpButton';

function currentDefaultYear() {
  const now = new Date();
  return now.getFullYear() + (now.getMonth() >= 9 ? 1 : 0);
}

export default function AdminDrawPage() {
  const [year, setYear] = useState(currentDefaultYear());
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [drawing, setDrawing] = useState(false);
  const [error, setError] = useState('');
  const [confirmReset, setConfirmReset] = useState(false);

  useEffect(() => { loadStatus(); }, [year]);

  async function loadStatus() {
    setLoading(true);
    try {
      const data = await api.getDrawStatus(year);
      setStatus(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleDraw() {
    setError('');
    setDrawing(true);
    try {
      await api.performDraw(year);
      await loadStatus();
    } catch (err) {
      setError(err.message);
    } finally {
      setDrawing(false);
    }
  }

  async function handleReset() {
    setError('');
    try {
      await api.resetDraw(year);
      setConfirmReset(false);
      await loadStatus();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div style={styles.page}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.5rem' }}>
        <HelpButton title="🎰 Sorteo del Amigo Invisible">
          <p>Pulsa el botón para emparejar automáticamente a todos los participantes activos.</p>
          <p>El sistema respeta las <strong>incompatibilidades</strong> que hayas marcado en "Usuarios" (parejas que no se pueden tocar entre sí).</p>
          <p>Cada persona verá únicamente a quién le toca regalar a ella, nunca el resultado de los demás.</p>
          <p>Puedes navegar entre años con las flechas, y repetir un sorteo si fuera necesario (esto borra el anterior).</p>
        </HelpButton>
      </div>

      <div style={styles.yearSelector}>
        <button className="btn btn-ghost" onClick={() => setYear(y => y - 1)}>←</button>
        <h2 style={styles.year}>🎰 Sorteo {year}</h2>
        <button className="btn btn-ghost" onClick={() => setYear(y => y + 1)}>→</button>
      </div>

      {loading ? (
        <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Cargando...</p>
      ) : status?.done ? (
        <div className="card" style={styles.doneCard}>
          <span style={{ fontSize: '3rem' }}>✅</span>
          <h3 style={{ color: 'var(--gold)', margin: '0.5rem 0' }}>Sorteo realizado</h3>
          <p style={{ color: 'var(--text-muted)', textAlign: 'center' }}>
            El sorteo para {year} ya está hecho. Cada persona puede ver su resultado en su sección de Amigo Invisible.
          </p>

          {!confirmReset ? (
            <button className="btn btn-danger" style={{ marginTop: '1rem' }} onClick={() => setConfirmReset(true)}>
              Repetir sorteo
            </button>
          ) : (
            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
              <p style={{ color: 'var(--red-light)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
                ⚠ Esto borrará el sorteo actual de {year}. ¿Seguro?
              </p>
              <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                <button className="btn btn-ghost" onClick={() => setConfirmReset(false)}>Cancelar</button>
                <button className="btn btn-danger" onClick={handleReset}>Sí, repetir</button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="card" style={styles.pendingCard}>
          <span style={{ fontSize: '3rem' }}>🎁</span>
          <h3 style={{ color: 'var(--gold)', margin: '0.5rem 0' }}>Sorteo pendiente</h3>
          <p style={{ color: 'var(--text-muted)', textAlign: 'center', marginBottom: '1.5rem' }}>
            Pulsa el botón para emparejar a todos los participantes respetando las incompatibilidades.
          </p>
          <button
            className="btn btn-primary"
            style={{ fontSize: '1.1rem', padding: '0.9rem 2rem' }}
            onClick={handleDraw}
            disabled={drawing}
          >
            {drawing ? 'Sorteando... 🎲' : '🎄 Hacer el sorteo'}
          </button>
        </div>
      )}

      {error && <p className="error-msg" style={{ textAlign: 'center', marginTop: '1rem' }}>⚠ {error}</p>}
    </div>
  );
}

const styles = {
  page: { padding: '1rem' },
  yearSelector: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    marginBottom: '1.5rem',
  },
  year: { color: 'var(--gold)', fontSize: '1.3rem', minWidth: '160px', textAlign: 'center' },
  doneCard: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    padding: '2rem 1.5rem',
  },
  pendingCard: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    padding: '2rem 1.5rem',
  },
};
